<template>
  <CRow>
    <CCol col="12" md="12">
      <CCardBody>
        <CRow>
          <CCol sm="6">
            <CRow>
              <CCol sm="5">
                <h5>Name</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.name }}</h5>
              </CCol>
              <br />
              <br />
              <hr />
              <CCol sm="5">
                <h5>Symbol</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.symbol }}</h5>
              </CCol>
              <br />
              <br />
              <CCol sm="5">
                <h5>Total supply</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.supply }}</h5>
              </CCol>
              <br />
              <br />
              <CCol sm="5">
                <h5>Ethereum Address</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.ethAddress }}</h5>
              </CCol>
              <br />
              <br />
              <CCol sm="5">
                <h5>Contract Address</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.conAddress }}</h5>
              </CCol>
              <br />
              <br />
              <CCol sm="5">
                <h5>Private key</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.privatekey }}</h5>
              </CCol>
              <br />
              <br />
              <!-- <CCol sm="5">
                <h5>Country</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6" v-if="allcon">
                <h5>{{ this.FormData1.supply }}</h5>
              </CCol>
              <CCol sm="6" v-if="partcon">
                <h5 v-for="items in this.FormData2.country" :key="items">
                  {{ items }}
                </h5>
              </CCol>  <br /> -->
              
                <CCol sm="5">
                <h5>DailyLimit</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.dailyLimit }}</h5>
              </CCol>  <br />
              <br />
               <CCol sm="5">
                <h5>MaxLimit</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.maxLimit }}</h5>
              </CCol>  <br />
              <br />
               <CCol sm="5">
                <h5>UserLimit</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.Userlimit }}</h5>
              </CCol>  <br />
              <br />
               <CCol sm="5">
                <h5>CoinQty</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.coinQty }}</h5>
              </CCol>  <br />
              <br />
               <!-- <CCol sm="5">
                <h5>Message 5</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData2.msg5 }}</h5>
              </CCol>  <br />
              <br /> -->
               <CCol sm="5">
                <h5>TotalSupply</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData2.supply }}</h5>
              </CCol>
              <br />
              <br />
            </CRow>
          </CCol>
          <CCol sm="6">
            <CRow>
              <CCol sm="5">
                <h5>Company</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.CompanyName }}</h5> </CCol
              ><br /><br />
              <CCol sm="5">
                <h5>Description</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.description }}</h5> </CCol
              ><br /><br />
              <CCol sm="5">
                <h5>Logo</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <!-- <h5>{{this.FormData1.logo}} </h5> -->
                <img v-if="image1"
                  :src="this.FormData1.logo"
                  style="width: 100px; border-radius: 100px; height: 100px"
                />
                 <img v-else
                  src="img/noimage.png"
                  style="width: 100px; border-radius: 100px; height: 100px"
                />
                
              </CCol>
              <CCol sm="5">
                <h5>Display logo</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <!-- <h5>{{this.FormData1.logo}} </h5> -->
                <img v-if="image2"
                  :src="this.FormData1.displaylogo"
                  style="width: 100px; border-radius: 100px; height: 100px"
                />
                  <img v-else
                  src="img/noimage.png"
                  style="width: 100px; border-radius: 100px; height: 100px"
                />
              </CCol>
              <CCol sm="5">
                <h5>Capture logo</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <!-- <h5>{{this.FormData1.logo}} </h5> -->
                <img v-if="image3"
                  :src="this.FormData1.capturelogo"
                  style="width: 100px; border-radius: 100px; height: 100px"
                />
                 <img v-else
                  src="img/noimage.png"
                  style="width: 100px; border-radius: 100px; height: 100px"
                />
              </CCol>
              <br />
              <br />

              <!-- <CCol sm="5">
                <h5>Location</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5 v-for="items in this.FormData2.location" :key="items">
                  {{ items.label }}
                </h5>
              </CCol> -->
              <br />
              <br />

              <CCol sm="5">
                <h5>Linkedin</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.linkedID }}</h5>
              </CCol>  <br />
              <br />
              <CCol sm="5">
                <h5>Twitter</h5>
              </CCol>
              <CCol sm="1">:</CCol>
              <CCol sm="6">
                <h5>{{ this.FormData1.twitterId }}</h5>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCol>
  </CRow>
</template>
<script >
import { APIService } from "../../apiservice.js";

export default {
  data() {
    return {
      FormData1: {},
      FormData2: {},
      image1:false,
      image2:false,
      image3:false,
      allcon:false,
      partcon:false
    };
  },
  methods: {
    nextTab() {
      // console.log("tabbutton form2");
      this.$emit("pass6", this.token);
    },
  },
  mounted() {
    this.$root.$on("pass4", (value) => {
      this.FormData1 = value;
      // console.log("FormData1",this.FormData1)
      if(this.FormData1.logo.length > 0){
        this.image1= true;
      }
      if(this.FormData1.displaylogo.length > 0){
        this.image2 = true;
      }
      if(this.FormData1.capturelogo.length > 0){
        this.image3 = true;
      }
      //  console.log("returndata allCountry",this.FormData1.allCountry);
      if(this.FormData1.allCountry==true){
        this.allcon=true;
      }
      //  console.log("returndata particularCountry",this.FormData1.particularCountry);
       if(this.FormData1.particularCountry==true){
         this.partcon=true;
      }
      // console.log("returndata pass4", this.FormData1.symbol);
    });
    this.$root.$on("pass5", (value) => {
      this.FormData2 = value;
      // console.log("returndata pass5", this.FormData2);
    });
  },
  created: {},
};
</script>